import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { setConsentResolvedState } from 'actions/consent'
import { consentModule } from 'services/consent/consent_module'

// Mirrors `consentModule` into Redux so selectors (e.g. `isCookiesAllowedSelector`)
// stay reactive. The `hide_gdpr_banner=true` backward-compat seed happens
// synchronously at module load in `services/consent/consent_module.js` and
// `reducers/consent.js`, so the very first render of consumers already sees the
// correct state; this bridge then carries any subsequent host CMP or OneTrust
// updates through to Redux.
export const ConsentStateBridge = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const syncState = (state) => {
      dispatch(setConsentResolvedState({
        categories: state.categories,
        source: state.source,
      }))
    }

    syncState(consentModule.getState())
    return consentModule.onChange(syncState)
  }, [dispatch])

  return null
}
